import React from "react";
import PropTypes from "prop-types";

import moment from "moment";
import Select from "react-select";
import { IoClose } from "react-icons/io5";
import { Form, Input } from "formsy-react-components";

import { DayPickerRangeController } from "react-dates";

const TimesheetFilters = ({
  user,
  users,
  period,
  range,
  onFocus,
  onChangeUser,
  onChangeDate,
  showDate,
  auth
}) => (
  <Form className="time-sheet header form">
    <Select
      className="react-select-container"
      classNamePrefix="react-select-container"
      value={user}
      onChange={onChangeUser}
      options={
        auth.maxRole > 2000
          ? users.map((u) => ({ value: u._id, label: u.full_name }))
          : [{ value: auth.user._id, label: auth.user.full_name }]
      }
    />
    <Input
      name="period"
      className="form-control pull-right"
      value={period}
      onFocus={onFocus}
      addonBefore={
        <span
          className="glyphicon glyphicon-calendar"
          role="presentation"
          onKeyDown={() => {}}
          onClick={onFocus}
        />
      }
    />
    {showDate && (
      <React.Fragment>
        <IoClose
          style={{
            position: "absolute",
            right: "5px",
            top: "5px",
            zIndex: "99999",
            color: auth?.isNightMode ? "white" : "black"
          }}
          onClick={onFocus}
        />
        <DayPickerRangeController
          startDate={moment(range[0]?.date)}
          endDate={moment(range[range.length - 1]?.date)}
          numberOfMonths={1}
          focusedInput="startDate"
          enableOutsideDays
          keepOpenOnDateSelect={false}
          onDatesChange={onChangeDate}
          onFocusChange={onFocus}
        />
      </React.Fragment>
    )}
  </Form>
);

TimesheetFilters.propTypes = {
  user: PropTypes.object,
  users: PropTypes.array,
  period: PropTypes.string,
  range: PropTypes.array,
  onFocus: PropTypes.func,
  onChangeUser: PropTypes.func,
  onChangeDate: PropTypes.func,
  showDate: PropTypes.bool,
  auth: PropTypes.object
};

export default TimesheetFilters;
